// FullCalendar wird nur geladen, wenn die Seite einen Terminkalender enthält (dynamischer Chunk)
if (document.querySelector('[data-event-calendar]')) {
    import('./eventCalendarInit.js');
}
